import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ValueFirstOnboardingService } from '../../services/value-first-onboarding.service';
import {
  AGENCY_PATH_PRICE,
  BRAND_PATH_PRICE,
  ValueFirstPath,
} from '../../services/value-first-onboarding.types';

@Component({
  selector: 'vf-path-step',
  imports: [RouterLink],
  templateUrl: './path-step.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block min-h-full' },
})
export class VfPathStep {
  readonly onboarding = inject(ValueFirstOnboardingService);

  readonly options = computed(() => {
    const currency = this.onboarding.displayCurrency();
    return [
      {
        id: 'brand' as ValueFirstPath,
        title: 'Brand',
        description: 'I run marketing for a brand and want to deploy creators directly.',
        price: currency ? BRAND_PATH_PRICE[currency] : '14-day free trial',
        tile: 'bg-linear-to-br from-brand-studio-dark to-brand-studio',
        icon: 'building' as const,
      },
      {
        id: 'agency' as ValueFirstPath,
        title: 'Agency',
        description: 'I represent multiple brands and coordinate campaigns at scale.',
        price: currency ? AGENCY_PATH_PRICE[currency] : '14-day free trial',
        tile: 'bg-linear-to-br from-brand-agency-dark to-brand-agency',
        icon: 'layers' as const,
      },
      {
        id: 'creator' as ValueFirstPath,
        title: 'Creator',
        description: 'I make content and want to find brand campaigns and get paid.',
        price: 'Join free',
        tile: 'bg-linear-to-br from-brand-deep-purple to-brand-purple',
        icon: 'user' as const,
      },
    ];
  });

  choose(path: ValueFirstPath): void {
    this.onboarding.selectPath(path);
  }
}
